import React, { useEffect, useState, useContext, useCallback } from 'react'
import _ from 'lodash'

import AppConfigContext from '../../../app_layout/app_config_context'
import { ApiHelper } from '../../../../helpers/apihelper'
import * as Constants from '../../../../helpers/constants'

import UserCard from './user_card'
import ActionButtons from '../actions_buttons'

const UserInfoCard = ({
  user,
  userId,
  planId,
  attachedUserIds = [],
  product,
  isCustom,
  onAttachSuccess,
  onDetachSuccess,
  onCancelSuccess
}) => {
  const { client } = useContext(AppConfigContext)
  const [userData, setUserData] = useState(user || null)
  const fetchUserInfo = useCallback(() => {
    if (!client || !userId) return
    const userInfoData = ApiHelper(client, 'USER_INFO')
    const body = {
      co_user_id: userId,
      user_id: userId,
      client_secret: Constants.CLIENT_SECRET
    }
    userInfoData.API(client, body)
      .then(res => {
        if (res?.status === Constants.CO_API.SUCCESS) {
          setUserData(res?.data?.data || res?.data)
        }
      })
  }, [client, userId])
  useEffect(() => {
    if (!_.isEmpty(user)) {
      setUserData(user)
      return
    }
    if (userId) {
      fetchUserInfo()
    }
  }, [user, userId, fetchUserInfo])
  if (!userData) return null
  const isOwner = userData.user_role === 'owner'
  const isAttached = attachedUserIds
    .map(id => String(id))
    .includes(String(userId))
  const subscriptions = Array.isArray(userData?.subscription)
    ? userData.subscription
    : userData?.subscription
      ? [userData.subscription]
      : []
  const displaySubscription = isOwner
    ? subscriptions.find(ele => ele.product_type === 'plan') || null
    : null
  const planSubscription = subscriptions.find(
    sub => String(sub.co_product_id) === String(planId)
  )
  const status = planSubscription?.status?.toLowerCase()
  const isActive = status === 'active'
  const isCancelled = status === 'cancelled'
  return (
    <div className="product-user-card">
      <UserCard
        user={userData}
        planSubscription={displaySubscription}
      />
      {isOwner && 
      userData?.status === 'active' &&
      userData?.account_status === 'live' &&
      (
        <ActionButtons
          user={userData}
          planId={planId}
          product={product}
          isAttached={isAttached}
          isActive={isActive}
          isCancelled={isCancelled}
          isCustom={isCustom}
          planSubscription={planSubscription}
          fetchUser={fetchUserInfo}
          onAttachSuccess={onAttachSuccess}
          onDetachSuccess={onDetachSuccess}
          onCancelSuccess={onCancelSuccess}
        />
      )}

    </div>
  )
}

export default UserInfoCard